var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMissionLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.7663 17.7667C17.1718 18.3581 16.8361 19.1613 16.833 20C16.833 20.8398 17.1666 21.6453 17.7605 22.2392C18.3544 22.833 19.1598 23.1667 19.9997 23.1667C20.8383 23.1636 21.6415 22.8279 22.233 22.2333",
    stroke: "#003C9D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 10.5C18.1211 10.5 16.2844 11.0572 14.7221 12.101C13.1598 13.1449 11.9422 14.6286 11.2231 16.3645C10.5041 18.1004 10.316 20.0105 10.6825 21.8534C11.0491 23.6962 11.9539 25.3889 13.2825 26.7175C14.6111 28.0461 16.3038 28.9509 18.1466 29.3175C19.9895 29.684 21.8996 29.4959 23.6355 28.7769C25.3714 28.0578 26.8551 26.8402 27.899 25.2779C28.9428 23.7156 29.5 21.8789 29.5 20",
    stroke: "#003C9D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9998 4.16666C16.8683 4.16666 13.8071 5.09526 11.2033 6.83505C8.59954 8.57484 6.57014 11.0477 5.37175 13.9408C4.17336 16.834 3.85981 20.0176 4.47074 23.0889C5.08168 26.1603 6.58966 28.9815 8.80399 31.1958C11.0183 33.4102 13.8395 34.9182 16.9109 35.5291C19.9823 36.14 23.1658 35.8265 26.059 34.6281C28.9522 33.4297 31.425 31.4003 33.1648 28.7965C34.9046 26.1927 35.8332 23.1315 35.8332 20M25.8748 14.1267L21.5832 18.4167",
    stroke: "#003C9D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8999 9.73999L29.4999 10.5L30.2599 5.09999C30.2655 5.03726 30.2522 4.9743 30.2218 4.91915C30.1914 4.864 30.1453 4.81915 30.0893 4.79035C30.0333 4.76155 29.97 4.75009 29.9075 4.75745C29.8449 4.76481 29.786 4.79064 29.7382 4.83165L26.1582 8.39332C25.7905 8.76369 25.52 9.2192 25.3709 9.71933C25.2217 10.2195 25.1985 10.7487 25.3032 11.26L25.8732 14.1267L28.7399 14.695C29.2512 14.7997 29.7804 14.7765 30.2805 14.6273C30.7807 14.4782 31.2362 14.2077 31.6065 13.84L35.1665 10.2617C35.2077 10.2138 35.2336 10.1547 35.2409 10.092C35.2482 10.0292 35.2366 9.96576 35.2076 9.90969C35.1786 9.85361 35.1335 9.80749 35.078 9.77725C35.0226 9.74701 34.9594 9.73403 34.8965 9.73999",
    stroke: "#003C9D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMissionLogo);
export default __webpack_public_path__ + "static/media/missionLogo.6ffdb2b387e78d8a4ede62cb453c3a56.svg";
export { ForwardRef as ReactComponent };